module.exports = __webpack_public_path__ + "static/media/scott.295e7609.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/scott.png
// module id = 958
// module chunks = 0